module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAABI0lEQVQ4T62UO07DUBBFzzzL4lNQsQR+AbYASyAhUWKMUlFYsAWKNGQNNDTuQmQkCmApgNgCnyLCEkHBHmShoGAlIZb9+nt039w7I5VD58SotEFscjyjUe/Tsj2pugcvwHIO1q9UlNsE+ASspYADILtj5SoBPgClv0B5R/VIoSmGMjqrf7mcAISlufkF3/f71XrdwTJtxKzwL3kKcIBs33Q694k3z/Ps5zBsGY1PATPZ7xSgxrp53e0+jor3HackcIaR2nhoRuAQstesr1uRdSGwk5r95BmOczgU11x3S+EcdDcXsOa6G0qcLEH2L6dDeQ3DFnlCsb6ixSAIPiqNRsMYSWqzmqM2o8WWMjprs39SLnz1CjsOIHdS1PkSjd/6xjr+BiykjxnIxf1MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/play.png
// module id = Hu2M
// module chunks = 1